export const UPLOAD_FILE = "file";
export const RULE_NAME = "ruleName";
export const RULE_ID = "distributionRuleId";
export const BUDGET_TYPE = "budgetType";
export const COMMUNITY_ID = "communityId";
export const YEAR = "year";